import { render, staticRenderFns } from "./InformationAlvara.vue?vue&type=template&id=54ae88cb&scoped=true"
import script from "./InformationAlvara.vue?vue&type=script&lang=js"
export * from "./InformationAlvara.vue?vue&type=script&lang=js"
import style0 from "./InformationAlvara.vue?vue&type=style&index=0&id=54ae88cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae88cb",
  null
  
)

export default component.exports